<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6">
          <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb/>
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-md-12">

          <div class="row">

            <div class="col-sm" v-for="products in productos" v-bind:key="products.productName">
              <card header-classes="text-center bg-transparent"
                    body-classes="text-center"
                    gradient="primary"
                    :class="(productoLock==products.payProductId) ? 'seleccionado':'' ">

                <div class="mb-3">

                  <h4 class="text-secondary ls-1py-3 mb-0">
                    {{ products.productName }}
                  </h4>
                  <h1 class="display-3 text-yellow mb-0">
                    ${{ numberWithCommas(products.amount) }}
                  </h1>

                </div>

                <base-button type="danger"
                             @click.prevent="getProduct(products)"
                             >
                             Elegir este pack
                </base-button>

              </card>
            </div>
          </div>
          <div class="row justify-content-end">

            <div class="col-lg-4 col-md-6">

              <card>

                <h3 slot="header" class="mb-0">Selecciona pasarela de pago</h3>

                <div class="row">

                  <div class="col-lg-12" v-for="plataforma in plataformas" v-bind:key="plataforma.paymentPlatformName">
                    <card body-classes="text-left px-2 pb-2">

                      <base-radio :name="plataforma.paymentPlatformName"
                                  class="mb-3"
                                  v-model="radio.radio1">
                                  <p>{{ plataforma.paymentPlatformName }}</p>
                      </base-radio>

                    </card>
                  </div>

                </div>

              </card>

            </div>

            <div class="col-md">
              <card body-classes="pb-4">

                <h3 slot="header" class="mb-0">Detalle de tu compra</h3>

                <div class="row">
                  <div class="col-lg">

                    <p>Este es el resumen de la compra que vas a realizar.</p>

                    <div>
                      <ul class="list-group list-group-flush mb-5">
                        <li class="list-group-item">Cantidad de SMS:
                          <span class="font-weight-700" > {{ (productoSelect.credits==undefined ? '' : numberWithCommas(productoSelect.credits)) }}</span>
                        </li>
                        <li class="list-group-item">Total a pagar:
                          <span class="font-weight-700" > ${{ (productoSelect.amount==undefined ? '' : numberWithCommas(productoSelect.amount)) }}</span>
                        </li>
                        <li class="list-group-item">Método de Pago: <span class="font-weight-700" > {{ radio.radio1 }} </span></li>
                      </ul>
                    </div>

                  </div>

                  <div class="col-lg">

                    <form>
                      <div class="d-flex justify-content-around">
                        <base-radio name="boleta"
                                    class="mb-3"
                                    v-model="radio.radio2">
                                    Boleta
                        </base-radio>

                        <base-radio name="factura"
                                    class="mb-3"
                                    v-model="radio.radio2">
                                    Factura
                        </base-radio>
                      </div>

                        <base-input label="Nombres"
                                    type="text"
                                    v-model="transfer.nombre" />
                        <base-input label="Apellido"
                                    type="text"
                                    v-model="transfer.apellido"  />
                        <label class="form-control-label">
                          RUT
                          <el-tooltip content="Ingresar RUT sin guión" placement="top">
                            <i class="btn-tooltip fas fa-question-circle text-gray"></i>
                          </el-tooltip>
                        </label>
                        <base-input label=""
                                    type="text"
                                    v-model="transfer.rut">
                        </base-input>
                        <base-input label="Dirección"
                                    type="text"
                                    v-model="transfer.direccion" />
                        <base-input label="Teléfono"
                                    type="number"
                                    v-model="transfer.telefono" />

                        <div class="text-right">
                          <base-button type="celcompink" @click="iniciarPago">
                            Comprar
                          </base-button>
                        </div>


                    </form>

                  </div>
                  </div>


              </card>
            </div>

          </div>

        </div>

      </div>

    </div>

  </div>
</template>
<script>
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import StatsCard from '@/components/Cards/StatsCard';

  import { BasePagination, Modal, Dialog } from '@/components';
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  import moment from 'moment';

  import AES256 from 'aes-everywhere';
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import Config from '@/config/config.js'
  import { getUser, setUser, encryptAES, horaAhora, obtenerInfoCuenta, onPermissionsUser } from '@/util/util.js';

  Vue.use(VueAxios, axios)
  Vue.use(Dialog)


  export default {
    components: {
      StatsCard,
      RouteBreadCrumb,
      Modal,
      Dialog
    },
    data() {
      return {
        radio: {
           radio1: "",
           radio2: "radio3"
         },
         productos: {},
         plataformas: [],
         productoSelect: {},
         plataformaSelect: {},
         productoLock: "",
         pagoLock: false,
         transfer:{
           nombre:"",
           apellido:"",
           rut:"",
           direccion:"",
           telefono:"",
           boleta:true
         }
      };
    },
    methods: {


     numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
     },
     obtenerProducts() {

      //this.$loading.show();   //delay default is 300ms

      let self = this;
      let user = getUser();

      let js = {
        "time_expired":horaAhora(),
        "customer":encodeURIComponent(JSON.stringify(user.customer)),
        "email": "",
        "password": "",
        "userPhone": "",
        "plan": "",
        "transaction": ""
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

      Vue.axios.post(Config.url_service+Config.payment_products, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {
            console.log(response);

            if (response.data.response === "200") {

              self.productos = response.data.data;
              console.log(response.data.data);

            } else {
              console.log("No se encontraron productos");
              alert("No se encontraron productos");

            }

            self.$loading.hide()

        })
        .catch(function (error) {
            console.log("No se encontraron productos",error);
            alert("No se encontraron productos");
            self.$loading.hide();
        });

      },
      obtenerPlataformas() {

      //this.$loading.show()   //delay default is 300ms

      let self = this;
      let user = getUser();

      let js = {
        "time_expired":horaAhora(),
        "customer":encodeURIComponent(JSON.stringify(user.customer)),
        "email": "",
        "password": "",
        "userPhone": "",
        "plan": "",
        "transaction": ""
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

      Vue.axios.post(Config.url_service+Config.payment_plataforms, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {
            console.log(response);

            if (response.data.response === "200") {

              self.plataformas = response.data.data;
              console.log(response.data.data);

            } else {
              console.log("No se encontraron plataformas");
              alert("No se encontraron plataformas");
            }

            self.$loading.hide()

        })
        .catch(function (error) {
            console.log("No se encontraron plataformas",error);
            alert("No se encontraron plataformas");
            self.$loading.hide();
        });

      },
      getProduct(products) {
        let self = this;

        self.productoSelect = products;
        self.productoLock = products.payProductId;

      },
      iniciarPago(){


        this.$loading.show()   //delay default is 300ms

        let self = this;
        let user = getUser();

        let js = {
          "email": user.email,
          "password": user.password,
          "userPhone": "false",
          "trans_nombre": this.transfer.nombre,
          "trans_apellido": this.transfer.apellido,
          "trans_rut": this.transfer.rut,
          "trans_telefono": this.transfer.telefono,
          "trans_direccion": this.transfer.direccion,
          "boleta": (this.radio.radio2=="factura") ? "false" : "true",
          "plan":this.productoSelect.credits,
          "transaction":this.productoSelect.credits,
          "pasarela":this.radio.radio1,
          "time_expired":horaAhora(),
          "customer":encodeURIComponent(JSON.stringify(user.customer)),
        }


        if(user.email == "" || user.password == "" || this.transfer.nombre == "" || this.transfer.apellido == "" || this.transfer.rut == "" || this.transfer.telefono == "" || this.transfer.direccion == "" || this.productoSelect.credits == "" || this.radio.radio1 == "" || user.customer == ""){
          this.$loading.hide()
            swal({
                  title: "Debe completar todos los campos",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger btn-fill'
                })
                return false;
        }

        console.log(js);

        var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

        Vue.axios.post(Config.url_service+Config.payment_init_payment, body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        })
          .then(function (response) {
              console.log(response);

              if (response.data.response === "200") {

                console.log(response.data.data);
                window.location.href = response.data.data.urlRedirect;

              } else {
                console.log("No se pudo realizar pago");
                alert("No se pudo realizar pago");
              }

              self.$loading.hide()

          })
          .catch(function (error) {
              console.log("No se pudo realizar pago",error);
              alert("No se pudo realizar pago");
              self.$loading.hide();
          });
      },
      fechaFormato(unixTimestamp) {
        return moment(unixTimestamp).format('YYYY-MM-DD');
      },
    },
    mounted() {
      this.obtenerProducts();
      this.obtenerPlataformas();


      let user = getUser();

      if(user.monthlyLimit && !user.postpaid){
           window.location.href="/dashboard";
      }

     /* if(!onPermissionsUser('credits_transaction.xhtml', 'create')) {
        swal({
          title: 'No tienes los permisos para acceder a esta página.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-danger',
          type: 'error',
          }).then(function() {
            window.location.href="/dashboard";
        })

      }*/


    }
  };
</script>
<style>
  .custom-radio .custom-control-input ~ .custom-control-label {
    width: 100%;
  }
  .seleccionado {
    box-shadow: 0px 0px 0px 5px #ffd600;
  }
</style>
